import { render, staticRenderFns } from "./DuplicatedCustomersDialog.vue?vue&type=template&id=e376bd08&scoped=true"
import script from "./DuplicatedCustomersDialog.vue?vue&type=script&lang=js"
export * from "./DuplicatedCustomersDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e376bd08",
  null
  
)

export default component.exports